import { Loader2, Slack } from 'lucide-react'
import { toast } from '@/components/ui/sonner'
import { R } from '@/modules/api/actions'

import { SidebarMenuButton } from '@/components/ui/sidebar'
import { Small } from '../ui/typography'
import { useState } from 'react'

export function NavSlack() {
    const [loadState, setLoadState] = useState<'idle' | 'loading'>('idle')

    const joinSlack = async () => {
        setLoadState('loading')
        try {
            const response = await R.getSlackChannelInvite()
            if (response.isError) throw new Error(response.message)
            window.open(response.result.shareLink, '_blank')
        } catch (error) {
            toast.error(
                error instanceof Error ? error.message : 'Something went wrong',
            )
        } finally {
            setLoadState('idle')
        }
    }

    return (
        <SidebarMenuButton
            size="sm"
            variant="default"
            onClick={joinSlack}
            disabled={loadState === 'loading'}
        >
            {loadState === 'loading' ? (
                <>
                    <Loader2 className="animate-spin" />
                    <Small>Connecting...</Small>
                </>
            ) : (
                <>
                    <Slack />
                    <Small>Connect on Slack</Small>
                </>
            )}
        </SidebarMenuButton>
    )
}
